import React, { Component, Fragment } from 'react'
import ReactECharts from 'echarts-for-react';
import { Row, Typography } from 'antd'

const { Title } = Typography;

export default class PlaneStatistic extends Component {
    render(){
        if(this.props.tracks.length === 0){
            return
        }

        var dateStats = {}
        var tm = Date.now() - 30*24*3600*1000
        while(tm<Date.now()){
            const dt = new Date(tm)
            dateStats[dt.toLocaleDateString("zh-CN")] = 0
            tm += 24*3600*1000
        }

        this.props.tracks.map((track)=>{
            var date = new Date(track[0].postime)
            if (Object.keys(dateStats).includes(date.toLocaleDateString("zh-CN"))){
                dateStats[date.toLocaleDateString("zh-CN")] = dateStats[date.toLocaleDateString("zh-CN")]+1
            }else{
                dateStats[date.toLocaleDateString("zh-CN")] = 1
            }    
            return ""
        });

        const option = {
            // title: {
            //   text: '近30日活动统计',
            //   textStyle: {
            //       color: '#fff'
            //   }
            // },
            tooltip: {},
            // legend: {
            //   data:['销量']
            // },
            xAxis: {
              data: Object.keys(dateStats)
            },
            yAxis: {},
            series: [{
              name: '活动频次',
              type: 'bar',
              data: Object.values(dateStats)
            }]
        };

        if (Object.keys(dateStats).length>0){
            return (
                <Fragment>
                    <Title level={5} style={{textAlign:'center', color:'white'}}>近30日活动统计</Title>
                    <Row align='middle' justify='center'>                        
                        <ReactECharts option={option} style={{width:"65vw", height:"30vh"}}/>
                    </Row>
                </Fragment>
            )
        }else{
            return (
                <div></div>
            )
        }  
    }
}